import { environment } from '../../../environments/environment';

/** Lower-case: compared with `apiPathOf`'s lower-cased path. */
const SIGN_IN_API_PATH = '/api/auth/sign-in';

let apiOrigin: string | null = null;

/** Resolved lazily so a malformed apiUrl throws inside the app, where the error handler can show it. */
function resolveApiOrigin(): string {
  if (apiOrigin === null) {
    try {
      apiOrigin = new URL(environment.apiUrl).origin;
    } catch {
      throw new Error(
        `environment.apiUrl must be an absolute URL, and is "${environment.apiUrl}". ` +
          'Set it in the environment file for this build.',
      );
    }
  }

  return apiOrigin;
}

/** Compares origins, not a string prefix: `startsWith` would match a lookalike host and leak the token to it. */
export function isApiRequest(url: string): boolean {
  try {
    return new URL(url, document.baseURI).origin === resolveApiOrigin();
  } catch {
    return false;
  }
}

/** Lowercased because ASP.NET Core routes case-insensitively. Null for other origins. */
export function apiPathOf(url: string): string | null {
  try {
    const resolved = new URL(url, document.baseURI);

    return resolved.origin === resolveApiOrigin() ? resolved.pathname.toLowerCase() : null;
  } catch {
    return null;
  }
}

/** Fails start-up on a malformed apiUrl; otherwise `isApiRequest` would quietly never send the token. */
export function assertApiUrl(): void {
  resolveApiOrigin();
}

/** A 401 from sign-in means a wrong email or password, not an expired session. */
export function isSignInRequest(url: string): boolean {
  return apiPathOf(url) === SIGN_IN_API_PATH;
}
